export enum GeneralError {
	fetchFailed = 'fetch-failed',
}

export class Failure<Error> {
	public constructor(public readonly codes: Set<Error | GeneralError>) {}

	public has(error: Error | GeneralError): boolean {
		return this.codes.has(error);
	}

	public hasAnyOf(errors: Array<Error | GeneralError>): boolean {
		return errors.findIndex((error) => this.has(error)) >= 0;
	}

	public hasNot(error: Error | GeneralError): boolean {
		return !this.has(error);
	}

	public hasUnhandled(errors: Error[]): boolean {
		const handledSet = new Set<Error | GeneralError>(errors);
		return Array.from(this.codes).findIndex((error) => !handledSet.has(error)) >= 0;
	}
}
